import {
  legacyPlans,
  legacyPlansInfos,
} from '@constants/plans/legacySpacePlans'
import {
  newPlansInfos,
  PLGPlans,
  SLGPlans,
} from '@constants/plans/newSpacePlans'

export const plans = {
  ...legacyPlans,
  ...PLGPlans,
  ...SLGPlans,
}

export const plansInfos = [...legacyPlansInfos, ...newPlansInfos]

const plgPlansArray = [...newPlansInfos]
  .sort((a, b) => a.level - b.level)
  .filter((plan) => plan.priceIds)

export const lowestSelfServicePlan = plgPlansArray[0]
export const highestSelfServicePlan = plgPlansArray[plgPlansArray.length - 1]
